export * from './ng-uploader-options.class';
export * from './uploaded-file.class';
export * from './upload-rejected.class';



// WEBPACK FOOTER //
// /app/~/ngx-uploader/src/classes/index.ts